import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {
    awardListChannel = new Subject();
    detailChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.awardListChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
    }

    fetchAwardList = async (query) => {
        try {
            this.awardListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchAwardList(query).then((result) => {
                this.awardListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.awardListChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

}

export default IndexBloc